import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PurchaseImage from '../components/purchase-image';
import { SMALL_LANDSCAPE } from '../lib/image-versions';
import { showImageMagnifierModal } from '../actions';

class PurchaseImageContainer extends Component {
  constructor(props) {
    super(props);
    this.onImageClick = this.onImageClick.bind(this);
  }

  onImageClick() {
    this.props.actions.showImageMagnifierModal();
  }

  render() {
    return (
      <PurchaseImage
        className={this.props.className}
        version={this.props.version}
        alt={this.props.alt}
        images={this.props.images}
        defaultImageUrl={this.props.defaultImageUrl}
        onClick={this.onImageClick}
      />
    )
  }
}

const mapStateToProps = ({ purchases }, ownProps) => {
  const purchase = purchases.byId[purchases.current];
  const { product } = purchase;

  return {
    className: ownProps.className,
    version: ownProps.version || SMALL_LANDSCAPE,
    alt: product.name,
    images: product.images,
    defaultImageUrl: product.defaultImageUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      showImageMagnifierModal,
    }, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseImageContainer);




// WEBPACK FOOTER //
// ./src/containers/purchase-image.container.js